import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberVertical: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronGrabberVertical"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0002 3.58594L17.4144 9.00015L16.0002 10.4144L12.0002 6.41436L8.00015 10.4144L6.58594 9.00015L12.0002 3.58594ZM8.00015 13.5859L12.0002 17.5859L16.0002 13.5859L17.4144 15.0002L12.0002 20.4144L6.58594 15.0002L8.00015 13.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronGrabberVertical;
